module.exports = __webpack_public_path__ + "static/img_4434-b9e7407043988ad03a6df9c925e15f82.webp";